/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ChosenDescription } from './';
import {
    ChosenDescriptionFromJSON,
    ChosenDescriptionFromJSONTyped,
    ChosenDescriptionToJSON,
} from './';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChosenDescriptionWithOrigin
 */
export interface ChosenDescriptionWithOrigin {
    /**
     * 
     * @type {ChosenDescription}
     * @memberof ChosenDescriptionWithOrigin
     */
    value: ChosenDescription;
    /**
     * 
     * @type {Origin}
     * @memberof ChosenDescriptionWithOrigin
     */
    origin: Origin;
}

/**
 * Check if a given object implements the ChosenDescriptionWithOrigin interface.
 */
export function instanceOfChosenDescriptionWithOrigin(value: object): value is ChosenDescriptionWithOrigin {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function ChosenDescriptionWithOriginFromJSON(json: any): ChosenDescriptionWithOrigin {
    return ChosenDescriptionWithOriginFromJSONTyped(json, false);
}

export function ChosenDescriptionWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChosenDescriptionWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'value': ChosenDescriptionFromJSON(json['value']),
        'origin': OriginFromJSON(json['origin']),
    };
}

export function ChosenDescriptionWithOriginToJSON(value?: ChosenDescriptionWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': ChosenDescriptionToJSON(value['value']),
        'origin': OriginToJSON(value['origin']),
    };
}

